import { Box } from "@mui/material";
import { useScroll, useTransform, motion } from "framer-motion";
import { useEffect, useRef } from "react";

export const StickyContainer = ({ children, scrollMaping, bgColorMaping, enableStickyScroll = true }) => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    container: sectionRef,
    offset: ["start end", "end start"],
  });

  // scrollYProgress.onChange((latest) => {
  //   console.log("Scroll progress:", latest);
  // });

  const transitionBgColor = useTransform(
    scrollYProgress,
    scrollMaping,
    bgColorMaping
  );


  // ============================= Scroll Up If Not Fully Visible =============================
  // If this section is mounted and not in the viewport, scroll up to it
  const scrollUpIfNotFullyVisible = () => {
    if (!sectionRef.current) return;

    const rect = sectionRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Check if the top of the section is more than 50% visible but not fully in view
    if (rect.top > 0 && rect.top < viewportHeight * 0.5) {
      sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // Use Observer API to check if the section is in the viewport
  useEffect(() => {
    if (!enableStickyScroll) return;
    const target = sectionRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          scrollUpIfNotFullyVisible();
        }
      },
      { root: null, rootMargin: "0px", threshold: 0.5 }
    );
    observer.observe(target);
    return () => observer.unobserve(target);
  }, []);

  return (
    <motion.div style={{ background: transitionBgColor }}>
      <Box
        ref={sectionRef}
        sx={{
          height: '100dvh', // enables smooth scrolling
          overflowY: 'auto',
          overflowX: 'hidden',
          scrollSnapType: 'y mandatory', // enables smooth scrolling
          scrollBehavior: 'smooth', // enables smooth scrolling
        }}
      >
        {children}
      </Box>
    </motion.div>
  )
}